import { Menu, Transition } from "@headlessui/react";
import Tippy from "@tippyjs/react";
import { Fragment, useEffect, useRef, useState } from "react";
import { getPublicLink } from "../../../redux/actions/todoPerformance";
import { useDispatch, useSelector } from "react-redux";
import { GET_ALL_TODO_PERFORMANCE_DATA } from "../../../redux/constants";
// import CssTransition from "../../../component/layout/css-transition";

const LinkShare = ({ activity_assignment_id, customer_id }) => {
  const customerLink = `${process.env.REACT_APP_HOST_URL}/tracking/${activity_assignment_id}`;
  const publicLink = `${process.env.REACT_APP_HOST_URL}/public/${activity_assignment_id}`;
  // const [dropdownOpen, setDropdownOpen] = useState(false);
  // const trigger = useRef(null);
  // const dropdown = useRef(null);
  const [showCopyTooltip, setShowCopyTooltip] = useState(false);
  const [link, setLink] = useState(publicLink);
  const [loader, setLoader] = useState(false);
  const copyButtonIconRef = useRef(null);
  useEffect(() => {
    const copyButtonIcon = copyButtonIconRef.current;
    if (copyButtonIcon) {
      copyButtonIcon.addEventListener("click", handleCopyIcon);
    }
  }, [copyButtonIconRef.current]);

  const dispatch = useDispatch();
  const { performancedata } = useSelector((state) => state.todoPerformance);

  useEffect(() => {
    if (performancedata.is_public_link) {
      const publicLink = `${process.env.REACT_APP_HOST_URL}/public/${activity_assignment_id}`;
      setLink(publicLink);
    }
  }, [performancedata]);

  // // close on click outside
  // useEffect(() => {
  //   const clickHandler = ({ target }) => {
  //     if (!dropdown.current) return;
  //     if (
  //       !dropdownOpen ||
  //       dropdown.current.contains(target) ||
  //       trigger.current.contains(target)
  //     )
  //       return;
  //     setDropdownOpen(false);
  //   };
  //   document.addEventListener("click", clickHandler);
  //   return () => document.removeEventListener("click", clickHandler);
  // });

  // // close if the esc key is pressed
  // useEffect(() => {
  //   const keyHandler = ({ keyCode }) => {
  //     if (!dropdownOpen || keyCode !== 27) return;
  //     setDropdownOpen(false);
  //   };
  //   document.addEventListener("keydown", keyHandler);
  //   return () => document.removeEventListener("keydown", keyHandler);
  // });

  const handleCopyIcon = (text) => {
    try {
      navigator.clipboard.writeText(text);
    } catch (error) {
      console.error("Copy failed:", error);
    }
    setShowCopyTooltip(true);
    // setDropdownOpen(false);
  };

  const handleGenerateLink = (e) => {
    e.preventDefault();
    setLoader(true);
    const request = {
      activity_assignment_id,
      onSuccess: (data) => {
        setLoader(false);
        if (Boolean(data)) {
          const publicLink = `${process.env.REACT_APP_HOST_URL}/public/${activity_assignment_id}`;
          const modifiedPerformanceData = { ...performancedata };
          modifiedPerformanceData.is_public_link = true;
          dispatch({
            type: GET_ALL_TODO_PERFORMANCE_DATA,
            payload: modifiedPerformanceData,
          });
          setLink(publicLink);
        }
      },
      onError: () => {
        setLoader(false);
      },
    };

    dispatch(getPublicLink(request));
  };

  //   return (
  //     <div className="relative inline-flex">
  //       <button
  //         ref={trigger}
  //         className="btn-sm bg-[--bg-color-500] hover:bg-[--bg-color-700] text-white text-sm font-medium leading-5 px-3 relative"
  //         aria-haspopup="true"
  //         onClick={() => {
  //           setLink("");
  //           setDropdownOpen(!dropdownOpen);
  //         }}
  //         aria-expanded={dropdownOpen}
  //       >
  //         <div className="flex items-center">
  //           <span
  //             className={`fa-regular fa-link fill-current text-white pr-2`}
  //           ></span>
  //           <span>Share</span>
  //           <span
  //             className={`fa-sharp fa-solid fa-chevron-down fill-current text-white pl-5`}
  //           ></span>
  //         </div>
  //         {/* <span className="fa-sharp fa-solid fa-pipe absolute right-9 w-0.5 h-8 bg-white"></span> */}
  //         <hr className={`absolute right-9 w-0.5 h-8 bg-white`} />
  //       </button>

  //       <CssTransition
  //         className={`origin-top-right z-10 absolute top-full bg-white w-[301px] p-3 border border-[#E7E7E7] rounded shadow-lg overflow-hidden mt-1 right-0`}
  //         show={dropdownOpen}
  //         enter="transition ease-out duration-200 transform"
  //         enterStart="opacity-0 -translate-y-2"
  //         enterEnd="opacity-100 translate-y-0"
  //         leave="transition ease-out duration-200"
  //         leaveStart="opacity-100"
  //         leaveEnd="opacity-0"
  //       >
  //         <div
  //           ref={dropdown}
  //           onFocus={() => setDropdownOpen(true)}
  //           onBlur={() => setDropdownOpen(false)}
  //         >
  //           <div>
  //             <div className="space-y-2">
  //               <div className="text-[#2F80ED] font-inter font-semibold text-[13px]">
  //                 Customer Link
  //               </div>
  //               <div>
  //                 <div className="text-[#535860] font-inter text-[11px]">
  //                   This link redirects your customer directly to this
  //                 </div>
  //                 <div className="text-[#535860] font-inter text-[11px]">
  //                   booking. Authentication by customer is required.
  //                 </div>
  //               </div>
  //               <div className="flex items-center justify-between">
  //                 <a
  //                   className="text-[#2F80ED] underline font-inter text-[11px] pr-2 truncate"
  //                   href={customerLink}
  //                   target="_blabk"
  //                 >
  //                   {customerLink}
  //                 </a>
  //                 {/* <div></div> */}
  //                 <div>
  //                   <Tippy
  //                     content={showCopyTooltip ? "Copied" : "Copy"}
  //                     zIndex={99999}
  //                     key={showCopyTooltip ? "Copied" : "Copy"}
  //                   >
  //                     <button
  //                       type="button"
  //                       className="fa-solid fa-copy"
  //                       style={{
  //                         color: "#94A3B8",
  //                         fontSize: "16px",
  //                         marginRight: "10px",
  //                       }}
  //                       ref={copyButtonIconRef}
  //                       id="copyToken"
  //                       onClick={() => handleCopyIcon(customerLink)}
  //                     ></button>
  //                   </Tippy>
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //           <div>
  //             <div className="mt-5 space-y-2">
  //               <div className="text-[#2F80ED] font-inter font-semibold text-[13px]">
  //                 Public Asset Tracking Link
  //               </div>
  //               <div>
  //                 <div className="text-[#535860] font-inter text-[11px]">
  //                   This generates a public tracking link. Everyone
  //                 </div>
  //                 <div className="text-[#535860] font-inter text-[11px]">
  //                   with this link can see movements of the assets.
  //                 </div>
  //               </div>
  //               {link !== "" ? (
  //                 <div className="flex items-center justify-between">
  //                   <a
  //                     className="text-[#2F80ED] underline font-inter text-[11px] pr-2 truncate"
  //                     href={link}
  //                     target="_blabk"
  //                   >
  //                     {link}
  //                   </a>
  //                   {/* <div></div> */}
  //                   <div>
  //                     <Tippy
  //                       content={showCopyTooltip ? "Copied" : "Copy"}
  //                       zIndex={99999}
  //                       key={showCopyTooltip ? "Copied" : "Copy"}
  //                     >
  //                       <button
  //                         type="button"
  //                         className="fa-solid fa-copy"
  //                         style={{
  //                           color: "#94A3B8",
  //                           fontSize: "16px",
  //                           marginRight: "10px",
  //                         }}
  //                         ref={copyButtonIconRef}
  //                         id="copyToken"
  //                         onClick={() => handleCopyIcon(link)}
  //                       ></button>
  //                     </Tippy>
  //                   </div>
  //                 </div>
  //               ) : (
  //                 <button
  //                   onClick={handleGenerateLink}
  //                   className="btn-sm bg-white hover:bg-gray-50 text-black !shadow-none !border !border-[#E7E7E7] font-inter !text-[11px] font-medium leading-5 px-3"
  //                 >
  //                   Generate Public Link
  //                 </button>
  //               )}
  //             </div>
  //           </div>
  //         </div>
  //       </CssTransition>
  //     </div>
  //   );

  return (
    <div className="">
      <Menu as="div" className="relative bg-[--bg-color-500] rounded-md">
        <div>
          <Menu.Button
            className="btn-sm bg-[--bg-color-500] hover:bg-[--bg-color-700] text-white text-sm font-medium !shadow-none leading-5 px-3 relative"
          >
            <div className="flex items-center">
              <span
                className={`fa-regular fa-link fill-current text-white pr-2`}
              ></span>
              <span>Share</span>
              <span
                className={`fa-sharp fa-solid fa-chevron-down fill-current text-white pl-5`}
              ></span>
            </div>
            <span className="fa-sharp fa-solid fa-pipe absolute right-9 w-0.5 h-[30px] bg-white before:contents"></span>
            {/* <hr className={`absolute right-9 w-0.5 h-8 bg-white`} /> */}
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute z-60 bg-white right-0 mt-2 w-[350px] p-3 border border-[#E7E7E7] origin-top-right divide-y divide-gray-100 rounded-md shadow-sm focus:outline-none">
            <div className="px-1 py-1 ">
              <div className="space-y-2">
                <div className="text-[#2F80ED] font-inter font-semibold text-[15px]">
                  Customer Link
                </div>
                <div>
                  <div className="text-[#535860] font-inter text-[13px]">
                    This link redirects your customer directly to this
                  </div>
                  <div className="text-[#535860] font-inter text-[13px]">
                    booking. Authentication by customer is required.
                  </div>
                </div>
                <div className="flex items-center justify-between">
                  <a
                    className={`text-[#2F80ED] underline font-inter text-[12px] pr-2 truncate ${
                      !customer_id ? "cursor-not-allowed" : ""
                    }`}
                    href={customerLink}
                    target="_blabk"
                    // onClick={(e) => customer_id ? true : e.preventDefault()}
                    // onClick={(e) => e.preventDefault()}
                  >
                    {customerLink}
                  </a>
                  <div>
                    <Tippy
                      content={showCopyTooltip ? "Copied" : "Copy"}
                      zIndex={99999}
                      key={showCopyTooltip ? "Copied" : "Copy"}
                    >
                      <button
                        type="button"
                        className={`fa-solid fa-copy ${
                          !customer_id ? "cursor-not-allowed" : ""
                        }`}
                        style={{
                          color: "#94A3B8",
                          fontSize: "16px",
                          marginRight: "10px",
                        }}
                        ref={copyButtonIconRef}
                        id="copyToken"
                        onClick={(e) => {
                          e.preventDefault();
                          customer_id
                            ? handleCopyIcon(customerLink)
                            : handleCopyIcon("");
                        }}
                      ></button>
                    </Tippy>
                  </div>
                </div>
              </div>

              <div className="mt-5 space-y-2">
                <div className="text-[#2F80ED] font-inter font-semibold text-[15px]">
                  Public Asset Tracking Link
                </div>
                <div>
                  <div className="text-[#535860] font-inter text-[13px]">
                    This generates a public tracking link. Everyone
                  </div>
                  <div className="text-[#535860] font-inter text-[13px]">
                    with this link can see movements of the assets.
                  </div>
                </div>
                {link ? (
                  <div className="flex items-center justify-between">
                    <a
                      className="text-[#2F80ED] underline font-inter text-[12px] pr-2 truncate"
                      href={link}
                      target="_blabk"
                      // onClick={(e) => e.preventDefault()}
                    >
                      {link}
                    </a>
                    {/* <div></div> */}
                    <div>
                      <Tippy
                        content={showCopyTooltip ? "Copied" : "Copy"}
                        zIndex={99999}
                        key={showCopyTooltip ? "Copied" : "Copy"}
                      >
                        <button
                          type="button"
                          className="fa-solid fa-copy"
                          style={{
                            color: "#94A3B8",
                            fontSize: "16px",
                            marginRight: "10px",
                          }}
                          ref={copyButtonIconRef}
                          id="copyToken"
                          onClick={() => handleCopyIcon(link)}
                        ></button>
                      </Tippy>
                    </div>
                  </div>
                ) : loader ? (
                  <span className="ml-2">
                    <svg
                      className="animate-spin w-3 h-3 fill-current shrink-0"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z" />
                    </svg>
                  </span>
                ) : (
                  <button
                    onClick={handleGenerateLink}
                    className="btn-sm bg-white hover:bg-gray-50 text-black !shadow-none !border !border-[#E7E7E7] font-inter !text-[11px] font-medium leading-5 px-3"
                  >
                    Generate Public Link
                  </button>
                )}
              </div>
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
};

export default LinkShare;
